import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "count-items" }
const _hoisted_2 = { key: 0 }

import { computed } from "vue";
import { calculatePageCount } from "@/services/functions";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableItemCount',
  props: {
    itemsPerPage: {},
    currentPage: {},
    allElementsCount: {}
  },
  setup(__props: any) {

const props = __props;

const itemStartIndex = computed(() => {
  return (props.currentPage - 1) * props.itemsPerPage + 1
})

const itemEndIndex = computed(() => {
  return isLastPage.value ? props.allElementsCount : props.currentPage * props.itemsPerPage
})

const isLastPage = computed(() => {
  return props.currentPage === calculatePageCount(props.allElementsCount, props.itemsPerPage)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.allElementsCount > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(itemStartIndex.value) + " - " + _toDisplayString(itemEndIndex.value) + " / " + _toDisplayString(__props.allElementsCount), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})